import { Tooltip, TooltipProps } from "@mui/material";
import { forwardRef } from "react";
import { MuiBox } from "../box/MuiBox";

export const MuiTooltip = forwardRef<HTMLDivElement, TooltipProps>(
  ({ className, ...props }, ref) => {
    return (
      <Tooltip
        {...props}
        arrow
        classes={{ popper: className }}
        data-testid={props.id}
      >
        <MuiBox>{props.children}</MuiBox>
      </Tooltip>
    );
  },
);
